import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
import { formatBreakpointMods } from '../../helpers/util';
export var PageHeaderToolsItem = function PageHeaderToolsItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      visibility = _ref.visibility,
      isSelected = _ref.isSelected;
  return React.createElement("div", {
    className: css(styles.pageHeaderToolsItem, isSelected && styles.modifiers.selected, formatBreakpointMods(visibility, styles), className)
  }, children);
};